import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { SectionCard, EmptyState } from './TodaySchedule';

const formatMoney = (n) => new Intl.NumberFormat('ar-SA', { style: 'currency', currency: 'SAR', maximumFractionDigits: 0 }).format(n || 0);

const TrendTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;
  const data = payload[0]?.payload;
  return (
    <div className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs shadow-lg" dir="rtl" data-testid="trend-tooltip">
      <div className="mb-1 font-bold text-slate-700">{label}</div>
      <div className="text-teal-700">إيرادات: {formatMoney(data?.revenues)}</div>
      <div className="text-rose-600">مصروفات: {formatMoney(data?.expenses)}</div>
      <div className="mt-1 border-t border-slate-100 pt-1 font-semibold text-slate-800">صافي: {formatMoney(data?.net)}</div>
    </div>
  );
};

export const FinancialTrendChart = ({ trend }) => {
  const hasData = Array.isArray(trend) && trend.some((t) => t.revenues > 0 || t.expenses > 0);

  return (
    <SectionCard title="اتجاه الإيرادات والمصروفات" icon="chart" testId="financial-trend-chart">
      {!hasData ? (
        <EmptyState icon="chart" text="لا توجد بيانات مالية كافية لعرض الاتجاه الشهري بعد" testId="financial-trend-empty" />
      ) : (
        <div className="h-64 w-full" dir="ltr" data-testid="financial-trend-graph">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={trend} margin={{ top: 5, right: 5, left: 5, bottom: 0 }}>
              <defs>
                <linearGradient id="revGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#0d9488" stopOpacity={0.35} />
                  <stop offset="95%" stopColor="#0d9488" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="expGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#e11d48" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#e11d48" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
              <XAxis dataKey="month_label" tick={{ fontSize: 12, fill: '#64748b' }} axisLine={{ stroke: '#e2e8f0' }} tickLine={false} reversed />
              <YAxis tick={{ fontSize: 11, fill: '#94a3b8' }} axisLine={false} tickLine={false} width={40} />
              <Tooltip content={<TrendTooltip />} />
              <Area type="monotone" dataKey="revenues" stroke="#0d9488" strokeWidth={2} fill="url(#revGradient)" name="إيرادات" />
              <Area type="monotone" dataKey="expenses" stroke="#e11d48" strokeWidth={2} fill="url(#expGradient)" name="مصروفات" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </SectionCard>
  );
};

export default FinancialTrendChart;
